import React from "react"
import "./download-btn.sass"
import { gtag_report_conversion } from "../utils"
import classnames from "classnames"

export const DownloadBtns = ({ invert }) => {
  return (
    <div className="download-btns buttons">
      <a
        href="https://play.google.com/store/apps/details?id=com.ca.fantuan.customer&referrer=utm_source%3Dwebsite%2520%26utm_medium%3Dbanner%26utm_term%3Dget%2520the%2520app%26utm_content%3Dwebsite%2520%26utm_campaign%3Dwebsite%2520download%2520app"
        className={classnames("button apps android", { invert: invert })}
        onClick={() => gtag_report_conversion()}
      >
        Google Play
      </a>
      <a
        href="https://apps.apple.com/app/apple-store/id1218697769?pt=118602068&ct=website%20download%20app&mt=8"
        className={classnames("button apps apple", { invert: invert })}
        onClick={() => gtag_report_conversion()}
      >
        Apple Store
      </a>
      <a
        href="https://appgallery.cloud.huawei.com/ag/n/app/C101821915?locale=en_GB&source=appshare&subsource=C101821915&shareTo=com.huawei.email&shareFrom=appmarket&shareIds=100c332cc85949e1ad5c98a6e059607a_com.huawei.email&callType=SHARE"
        className={classnames("button apps huawei", { invert: invert })}
        onClick={() => gtag_report_conversion()}
      >
        APP Gallery
      </a>
    </div>
  )
}
